import Tippy from '@tippyjs/react';
import moment from 'moment';
import numeral from 'numeral';
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Alert, Badge } from 'react-bootstrap';
import DatePicker from 'react-date-picker';

import { useQuery, useQueryClient } from "react-query";
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import 'tippy.js/dist/tippy.css';
import { PageTitle } from "../../../../../_metronic/layout/core";
import { GetAllGarantiaRecepcion, GetEstadosRecepcionByTipoGarantia, GetGarantiasToRecepcion, SaveGarantiaRecepcion } from "../../../../api/Api";
import PermissionsGate from "../../../../api/PermissionsGate";
import ConfirmWithLoader from '../../../../Components/Modals/ConfirmWithLoader';
import Semaphore from '../../../../Components/Semaphore/Semaphore';
import WrappedAgTable from "../../../../Components/Table/WrappedAgTable";
import { createCustomDateFilterParams } from '../../../../Components/Utils/Utils';
import { SCOPES } from "../../../../config/permissions-map";
import { useGetUser } from '../../../../Hooks/CustomHooks';
import { Unauthorized } from "../../../Global/unauthorized";
import { CELL_CONSTANTS, GARANTIA_TIPO } from '../../../Utils/Constants';
import CardEx from '../../../../Components/Cards/CardEx';
import { color } from '@amcharts/amcharts4/core';
import cogoToast from 'cogo-toast';


export default function ListadoGarantiasRecepcion({ title }) {
    const { data: garantiasToRecepcionList, refetch: refetchGetGarantiasToRecepcion } = useQuery("getGarantiasToRecepcion", () => GetGarantiasToRecepcion({
        "tipo_garantia": null,
        "filter_by_recepcion": true,
        "filter_by_only_tipos_garantia_definida": true
    },));
    const { data: getGarantiaRecepcionList, refetch: refetchGetAllGarantiaRecepcion } = useQuery("getAllGarantiaRecepcion", GetAllGarantiaRecepcion);

    useEffect(() => {
        console.info(garantiasToRecepcionList, "garantiasToRecepcionList");
    }, [garantiasToRecepcionList])


    const queryClient = useQueryClient();
    const [showRecepcionModal, setShowRecepcionModal] = useState(false);
    const [isLoandingRecepcion, setIsLoandingRecepcion] = useState(false);
    const [isFinishRecepcion, setIsFinishRecepcion] = useState(false);
    const [messageErrorSave, setMessageErrorSave] = useState("");
    const [stateOptionList, setStateOptionList] = useState([]);
    const [recepcionEstadoSelected, setRecepcionEstadoSelected] = useState(null);
    const [dateAdmissionRecepcion, setDateAdmissionRecepcion] = useState(null);

    const user = useGetUser();

    const idGarantiaDetalle = useRef(null);
    const typeCodeGarantia = useRef("");
    const idEstadoGarantiaRecepcion = useRef(null);
    const nroDocumento = useRef("");

    const transformArrayOptions = useCallback((array) => {
        return array.map(item => ({
            value: item.id_garantia_recepcion_estado,
            label: item.descripcion
        }));
    }, []);

    const handleShowRecepcionModal = useCallback((props) => {
        setIsLoandingRecepcion(true);
        setDateAdmissionRecepcion(props.data.detalle_garantia.recepcion.fecha_ingreso_cuenta);
        idGarantiaDetalle.current = props.data.detalle_garantia.id_garantia_detalle;
        typeCodeGarantia.current = props.data.detalle_garantia.tipo_garantia.codigo;
        idEstadoGarantiaRecepcion.current = props.data.detalle_garantia.recepcion.id_garantia_recepcion_estado;

        if (props.data.detalle_garantia.tipo_garantia.codigo === GARANTIA_TIPO.GAR1_CARTA_FIANZA) {
            nroDocumento.current = props.data.detalle_garantia.nro_carta_fianza;
        } else {
            nroDocumento.current = props.data.detalle_garantia.nro_operacion;
        }

        setShowRecepcionModal(true);
        queryClient.fetchQuery('getStateRecepcionListByTypeGarantia',
            () => GetEstadosRecepcionByTipoGarantia(props.data.detalle_garantia.tipo_garantia.codigo)).then((result) => {
                if (result.success) {
                    setStateOptionList(transformArrayOptions(result.data));
                } else {
                }
            }).catch((err) => {
            }).finally(() => {
                if (!props.data.detalle_garantia.recepcion.id_garantia_recepcion_estado) {
                    setIsLoandingRecepcion(false);
                }
            });
    }, [queryClient, transformArrayOptions]);

    const header = useMemo(() => [
        {
            headerName: 'Id',
            field: 'detalle_garantia.id_garantia_detalle',
            pinned: 'left',
            width: 80
        },
        {
            headerName: 'Semáforos',
            field: 'semaforo_locatario',
            pinned: 'left',
            filter: false,
            sortable: false,
            width: 120,
            valueGetter: (params) => params.data,
            cellRenderer: (props) => props.data ? (
                <>
                    <div className="align-items-center d-flex h-100">
                        <Semaphore caption="LO" size={'25px'} fontSize={'11px'}
                            tooltipTitle={"Revisión de Locatario"}
                            lastUpdateDate={props.data.detalle_garantia?.revision_locatario?.fecha_revision}
                            lastUpdatedBy={props.data.detalle_garantia?.revision_locatario?.usuario_revisor}
                            tooltipDescription={props.data.detalle_garantia?.revision_locatario?.observaciones}
                            color={props.data.detalle_garantia.revision_locatario?.semaforo_color}>
                        </Semaphore>
                        <Semaphore caption="CO" size={'25px'} fontSize={'11px'}
                            tooltipTitle={"Revisión de Cobranza"}
                            lastUpdateDate={props.data.detalle_garantia?.revision_cobranza?.fecha_revision}
                            lastUpdatedBy={props.data.detalle_garantia?.revision_cobranza?.usuario_revisor}
                            tooltipDescription={props.data.detalle_garantia?.revision_cobranza?.observaciones}
                            color={props.data.detalle_garantia.revision_cobranza?.semaforo_color}>

                        </Semaphore>
                        {props.data.detalle_garantia.tipo_garantia.codigo === GARANTIA_TIPO.GAR1_CARTA_FIANZA &&
                            <Semaphore caption="TE" size={'25px'} fontSize={'11px'}
                                tooltipTitle={"Revisión de Tesorería"}
                                lastUpdateDate={props.data.detalle_garantia?.revision_tesoreria?.fecha_revision}
                                lastUpdatedBy={props.data.detalle_garantia?.revision_tesoreria?.usuario_revisor}
                                tooltipDescription={props.data.detalle_garantia?.revision_tesoreria?.observaciones}
                                color={props.data.detalle_garantia.revision_tesoreria?.semaforo_color}>
                            </Semaphore>
                        }
                    </div>
                </>
            ) : <></>
        },
        {
            headerName: 'Acciones',
            width: 100,
            filter: false,
            pinned: 'left',
            sortable: false,
            cellRenderer: (props) => props.data ? (
                <Tippy theme='light-border' content="Recepcionar">
                    <button className="btn btn-link garantias-font align-items-center d-flex h-100 justify-content-center mx-auto"
                        onClick={() => handleShowRecepcionModal(props)}>
                        <i className="fi fi-rr-hand-holding-box"></i>
                    </button>
                </Tippy>
            ) : <></>
        },

        {
            headerName: 'Contrato',
            field: 'garantia.nro_contrato',
            width: 100,
            filter: 'agTextColumnFilter',
            pinned: 'left',
        },
        {
            headerName: 'Datos Generales',
            stickyLabel: false,
            children: [
                {
                    headerName: 'Origen',
                    field: 'detalle_garantia.origen.nombre',
                    width: 110
                },
                {
                    headerName: 'Estado',
                    field: 'detalle_garantia.estado.nombre',
                    width: 110,
                    //columnGroupShow: 'open',
                },
                {
                    headerName: 'Tipo',
                    width: 120,
                    field: 'detalle_garantia.tipo_garantia.nombre',
                    //columnGroupShow: 'open',
                },

                {
                    headerName: 'RUC',
                    field: 'garantia.ruc',
                    width: 100,
                    filter: 'agTextColumnFilter',
                    //columnGroupShow: 'open',
                },
                {
                    headerName: 'Razon Social',
                    field: 'garantia.razon_social',
                    filter: 'agTextColumnFilter',
                    //columnGroupShow: 'open',
                },
                {
                    headerName: 'Mall',
                    field: 'garantia.mall.nombre',
                    width: 160,
                    //columnGroupShow: 'open',
                },
                {
                    headerName: 'Banco',
                    width: 100,
                    field: 'detalle_garantia.banco.codigo',
                    //columnGroupShow: 'open',
                },
                {
                    headerName: 'Importe',
                    field: 'detalle_garantia.importe',
                    type: 'rightAligned',
                    width: 100,
                    filter: 'agTextColumnFilter',
                    //columnGroupShow: 'open',
                    valueFormatter: function (params) {
                        return params.value ? `${numeral(params.value).format('0,0.00')}` : ``;
                    },
                },
                {
                    headerName: 'Moneda',
                    field: 'garantia.moneda.codigo',
                    width: 100,

                },
            ]
        },
        {
            headerName: 'Recepción',
            children: [
                {
                    headerName: 'Recepcionada?',
                    field: 'detalle_garantia.is_recepcionada',
                    width: 140,
                    cellRenderer: (props) => {
                        if (!props.data) {
                            return <></>;
                        }
                        var element = '';
                        if (props.data.detalle_garantia.is_recepcionada === true) {
                            element = <Badge pill bg="" style={{ backgroundColor: props.data.detalle_garantia.recepcion?.semaforo_color }} >Si Recepcionada</Badge>
                        }
                        else if (props.data.detalle_garantia.is_recepcionada === false) {
                            element = <Badge pill bg="" style={{ backgroundColor: props.data.detalle_garantia.recepcion?.semaforo_color }} >No Recepcionada</Badge>
                        } else {
                            element = <Badge pill bg="secondary">No Recepcionada</Badge>
                        }

                        return <div className="align-items-center d-flex h-100">{element}</div>
                    },
                },
                {
                    headerName: 'Semáforo',
                    field: 'detalle_garantia.recepcion.semaforo_color',

                    width: 100,
                    cellRenderer: (props) => props.data ? (<div className="align-items-center d-flex h-100">
                        <Semaphore
                            prefixMessage="Recepción registrada el"
                            caption=""
                            size={'25px'}
                            fontSize={'11px'}
                            tooltipTitle={"Recepción"}
                            lastUpdateDate={props.data.detalle_garantia?.recepcion?.creation_date}
                            lastUpdatedBy={props.data.detalle_garantia?.recepcion?.creation_by}
                            tooltipDescription={props.data.detalle_garantia.recepcion?.descripcion_recepcion_estado}
                            color={props.data.detalle_garantia.recepcion?.semaforo_color}>
                        </Semaphore>
                    </div>) : <></>
                },
                //////////////////////
                {
                    headerName: 'Fec.Ing. Cuenta',
                    width: 180,
                    field: 'detalle_garantia.recepcion.fecha_ingreso_cuenta',
                    filter: 'agDateColumnFilter',
                    filterParams: createCustomDateFilterParams,
                    valueFormatter: function (params) {
                        if (params.value == null) {
                            return CELL_CONSTANTS.NO_APLICA;
                        } else {
                            return (params.value) ? `${moment(params.value).format("DD/MM/yyyy")}` : null;
                        }
                    },
                    cellRenderer: (props) => {
                        const cellValue = props.valueFormatted ? props.valueFormatted : props.value;
                        if (cellValue == CELL_CONSTANTS.NO_APLICA) {
                            return <span className='cell-value-not-apply'>{cellValue}</span>
                        } else {
                            return cellValue;
                        }
                    }
                },
                {
                    headerName: 'Fec.Recepcion',
                    width: 180,
                    field: 'detalle_garantia.recepcion.creation_date',
                    filter: 'agDateColumnFilter',
                    filterParams: createCustomDateFilterParams,
                    valueFormatter: function (params) {
                        return (params.value) ? `${moment(params.value).format("DD/MM/yyyy")}` : null;
                    }
                },
                ////////////






                {
                    headerName: 'Estado',
                    width: 150,
                    field: 'detalle_garantia.recepcion.descripcion_recepcion_estado'
                },
            ]
        },
        {
            headerName: 'Garantía',
            stickyLabel: true,
            children: [
                {
                    headerName: 'Tipo',
                    field: 'detalle_garantia.tipo_garantia.nombre',
                    width: 100
                },

                {
                    headerName: 'Nro Carta Fianza',
                    field: 'detalle_garantia.nro_carta_fianza',
                    width: 150,
                    filter: 'agTextColumnFilter'
                },
                {
                    headerName: 'Nro Operación',
                    field: 'detalle_garantia.nro_operacion',
                    width: 150,
                    filter: 'agTextColumnFilter'
                },

                {
                    headerName: 'RUC',
                    field: 'garantia.ruc',
                    width: 100,
                    filter: 'agTextColumnFilter'
                },
                {
                    headerName: 'Razon Social',
                    field: 'garantia.razon_social',
                    filter: 'agTextColumnFilter'
                },
                {
                    headerName: 'Importe',
                    field: 'detalle_garantia.importe',
                    width: 100,
                    filter: 'agTextColumnFilter'
                },
                {
                    headerName: 'Moneda',
                    field: 'garantia.moneda.codigo',
                    width: 90,
                },
                {
                    headerName: 'Banco',
                    field: 'detalle_garantia.banco.codigo',
                    width: 100
                },
                {
                    headerName: 'F.Venc. Carta Fianza',
                    width: 180,
                    field: 'detalle_garantia.fecha_vencimiento_carta_fianza',
                    filter: 'agDateColumnFilter',
                    filterParams: createCustomDateFilterParams,
                    valueFormatter: function (params) {
                        return (params.value) ? `${moment(params.value).format("DD/MM/yyyy")}` : null;
                    }
                },
            ]
        },

    ], [handleShowRecepcionModal]);

    const headerGarantiasRecepcionadas = useMemo(() => [
        {
            headerName: 'Tipo',
            field: 'detalle_garantia.tipo_garantia.nombre',
            width: 100
        },
        {
            headerName: 'Recepcionada?',
            field: 'detalle_garantia.is_recepcionada',
            width: 140,
            columnGroupShow: 'open',
            cellRenderer: (props) => {
                if (!props.data) {
                    return <></>;
                }
                var element = '';
                if (props.data.detalle_garantia.is_recepcionada === true) {
                    element = <Badge pill bg="" style={{ backgroundColor: props.data.detalle_garantia.recepcion?.semaforo_color }} >Si Recepcionada</Badge>
                }
                else if (props.data.detalle_garantia.is_recepcionada === false) {
                    element = <Badge pill bg="" style={{ backgroundColor: props.data.detalle_garantia.recepcion?.semaforo_color }} >No Recepcionada</Badge>
                } else {
                    element = <Badge pill bg="secondary">No Recepcionada</Badge>
                }

                return <div className="align-items-center d-flex h-100">{element}</div>
            },
        },
        {
            headerName: 'Semáforo',
            field: 'detalle_garantia.recepcion.semaforo_color',
            columnGroupShow: 'open',
            width: 100,
            cellRenderer: (props) => props.data ? (<div className="align-items-center d-flex h-100">
                <Semaphore
                    prefixMessage="Recepción registrada el"
                    caption=""
                    size={'25px'}
                    fontSize={'11px'}
                    tooltipTitle={"Recepción"}
                    lastUpdateDate={props.data.detalle_garantia?.recepcion?.creation_date}
                    lastUpdatedBy={props.data.detalle_garantia?.recepcion?.creation_by}
                    tooltipDescription={props.data.detalle_garantia.recepcion?.descripcion_recepcion_estado}
                    color={props.data.detalle_garantia.recepcion?.semaforo_color}>
                </Semaphore>
            </div>) : <></>
        },
        {
            headerName: 'Nro Carta Fianza',
            field: 'detalle_garantia.nro_carta_fianza',
            width: 150,
            filter: 'agTextColumnFilter'
        },
        {
            headerName: 'Nro Operación',
            field: 'detalle_garantia.nro_operacion',
            width: 150,
            filter: 'agTextColumnFilter'
        },
        {
            headerName: 'Contrato',
            field: 'garantia.nro_contrato',
            width: 100,
            filter: 'agTextColumnFilter'
        },
        {
            headerName: 'RUC',
            field: 'garantia.ruc',
            width: 100,
            filter: 'agTextColumnFilter'
        },
        {
            headerName: 'Razon Social',
            field: 'garantia.razon_social',
            filter: 'agTextColumnFilter'
        },
        {
            headerName: 'Importe',
            field: 'detalle_garantia.importe',
            width: 100,
            filter: 'agTextColumnFilter',
            valueFormatter: function (params) {
                return params.value ? `${numeral(params.value).format('0,0.00')}` : ``;
            },
        },
        {
            headerName: 'Moneda',
            field: 'garantia.moneda.codigo',
            width: 90,
        },
        {
            headerName: 'Banco',
            field: 'detalle_garantia.banco.codigo',
            width: 100
        },
        {
            headerName: 'F.Venc. Carta Fianza',
            width: 190,
            field: 'detalle_garantia.fecha_vencimiento_carta_fianza',
            filter: 'agDateColumnFilter',
            filterParams: createCustomDateFilterParams,
            valueFormatter: function (params) {
                return (params.value) ? `${moment(params.value).format("DD/MM/yyyy")}` : null;
            }

        },
        {
            headerName: 'Fec.Ing. Cuenta',
            width: 170,
            field: 'detalle_garantia.recepcion.fecha_ingreso_cuenta',
            filter: 'agDateColumnFilter',
            filterParams: createCustomDateFilterParams,
            valueFormatter: function (params) {
                if (params.value == null) {
                    return CELL_CONSTANTS.NO_APLICA;
                } else {
                    return (params.value) ? `${moment(params.value).format("DD/MM/yyyy")}` : null;
                }
            },
            cellRenderer: (props) => {
                //debugger;
                const cellValue = props.valueFormatted ? props.valueFormatted : props.value;
                if (cellValue == CELL_CONSTANTS.NO_APLICA) {
                    return <span className='cell-value-not-apply'>{cellValue}</span>
                } else {
                    return cellValue;
                }
            }
        },
        {
            headerName: 'Fec.Recepcion',
            width: 150,
            field: 'detalle_garantia.recepcion.creation_date',
            filter: 'agDateColumnFilter',
            filterParams: createCustomDateFilterParams,
            valueFormatter: function (params) {
                return (params.value) ? `${moment(params.value).format("DD/MM/yyyy")}` : null;
            }
        }
    ], []);

    const agGridLista = useMemo(() => ({
        defaultColDef: {
            sortable: true,
            filter: true,
            resizable: true,
            minWidth: 10,
            floatingFilter: true,
            enableRowGroup: true
        },
        columnDefs: header,
        rowData: garantiasToRecepcionList?.data,
        pagination: true,
        rowGroupPanelShow: 'always',
        domLayout: "normal",
        rowSelection: 'single',
        autoGroupColumnDef: {
            headerName: 'Grupo',
            filter: 'agGroupColumnFilter'
        }
    }), [header, garantiasToRecepcionList?.data]);

    const agGridGarantiasRecepcionadas = useMemo(() => ({
        defaultColDef: {
            sortable: true,
            filter: true,
            resizable: true,
            minWidth: 10,
            floatingFilter: true,
            enableRowGroup: true
        },
        columnDefs: headerGarantiasRecepcionadas,
        rowData: getGarantiaRecepcionList?.data,
        pagination: true,
        rowGroupPanelShow: 'always',
        domLayout: "normal",
        rowSelection: 'single',
        autoGroupColumnDef: {
            headerName: 'Grupo',
            filter: 'agGroupColumnFilter'
        }
    }), [headerGarantiasRecepcionadas, getGarantiaRecepcionList?.data]);

    const handleConfirmRecepcionModal = useCallback(() => {
        setIsFinishRecepcion(false);
        setIsLoandingRecepcion(true);

        queryClient.fetchQuery('saveGarantiaRecepcion',
            () => SaveGarantiaRecepcion(idGarantiaDetalle.current,
                recepcionEstadoSelected.value,
                dateAdmissionRecepcion && moment(dateAdmissionRecepcion).toISOString(),
                user.email)
        ).then((result) => {
            if (result.success) {
                refetchGetGarantiasToRecepcion();
                refetchGetAllGarantiaRecepcion();
                setIsFinishRecepcion(true);
            } else {
                setMessageErrorSave("ERRORRR!!!!!")
            }
        }).catch((err) => {
            setMessageErrorSave("ERRORRR!!!!!")
        }).finally(() => {
            setIsLoandingRecepcion(false);
        });

    }, [dateAdmissionRecepcion, recepcionEstadoSelected, queryClient, refetchGetAllGarantiaRecepcion, refetchGetGarantiasToRecepcion, user.email]);

    const handleCloseRecepcionModal = useCallback((params) => {
        setIsFinishRecepcion(false);
        setIsLoandingRecepcion(false);
        setMessageErrorSave("");
        idGarantiaDetalle.current = null;
        idEstadoGarantiaRecepcion.current = null;
        nroDocumento.current = null
        setRecepcionEstadoSelected(null);
        setDateAdmissionRecepcion(null);
        setStateOptionList([]);
    }, []);

    const disabledButtonConfirmValidation = useCallback(() => {
        if (typeCodeGarantia.current === GARANTIA_TIPO.GAR1_CARTA_FIANZA) {
            return !recepcionEstadoSelected;
        } else {
            return !(recepcionEstadoSelected && dateAdmissionRecepcion);
        }
    }, [dateAdmissionRecepcion, recepcionEstadoSelected])

    useEffect(() => {
        if (stateOptionList.length > 0 && idEstadoGarantiaRecepcion.current) {
            setRecepcionEstadoSelected(stateOptionList.find(element => element.value === idEstadoGarantiaRecepcion.current))
        }
    }, [stateOptionList])

    useEffect(() => {
        if (recepcionEstadoSelected) {
            setIsLoandingRecepcion(false);
        }
    }, [recepcionEstadoSelected])

    const breadcrumbs = [
        { title: "Inicio", path: "/dashboard", isActive: true, isSeparator: false },
        { title: "", path: "", isActive: false, isSeparator: true },
        { title: "Garantías", path: "", isActive: false, isSeparator: false },
    ];

    return (
        <>
            <PermissionsGate RenderError={() => <Unauthorized />} scopes={[SCOPES.GARANTIAS_RECEPCION_GARANTIA]} >
                <PageTitle breadcrumbs={breadcrumbs}>{title}</PageTitle>
                <CardEx titleParent={title} 
                    title={"Listado de Garantías pendientes de Recepción"} 
                    isAvailableMaximized={true}
                    isAvailableBreadcrumbs={true}
                    isAvailableRefetch={true}
                    breadcrumbs={breadcrumbs} 
                    height={"700px"} 
                    onRefetch={async () => {
                        await refetchGetGarantiasToRecepcion();
                        cogoToast.success('Registros actualizado satisfactoriamente!', {
                            //hideAfter: 0,
                            heading: 'Listado de Garantías pendientes de Recepción',
                            position: 'top-right'
                        });
                    }}>
                    <WrappedAgTable
                        titleExcel={"listado_de_garantias_pendientes_recepcion"}
                        {...agGridLista} >
                    </WrappedAgTable>
                </CardEx>
                <div className="separator-h"></div>
                <CardEx titleParent={title} 
                    title={"Historial de Recepciones"} 
                    isAvailableMaximized={true}
                    isAvailableBreadcrumbs={true}
                    isAvailableRefetch={true}
                    breadcrumbs={breadcrumbs} 
                    height={"700px"} 
                    onRefetch={async () => {
                        await refetchGetAllGarantiaRecepcion();
                        cogoToast.success('Registros actualizado satisfactoriamente!', {
                            //hideAfter: 0,
                            heading: 'Historial de Recepciones',
                            position: 'top-right'
                        });
                }}>
                    <WrappedAgTable
                        titleExcel={"historial_de_garantias_recepcionadas"}
                        {...agGridGarantiasRecepcionadas} >
                    </WrappedAgTable>
                </CardEx>
                <ConfirmWithLoader
                    showModal={showRecepcionModal}
                    setShowModal={setShowRecepcionModal}
                    title={"Recepción de Garantia"}
                    isLoading={isLoandingRecepcion}
                    isFinish={isFinishRecepcion}
                    textButton={"Guardar"}
                    textButtonCancel={"Cerrar"}
                    onConfirm={handleConfirmRecepcionModal}
                    onClose={handleCloseRecepcionModal}
                    hideContentInLoading={false}
                    hideActionAfterConfirm={false}
                    disabledConfirmButton={disabledButtonConfirmValidation()}>

                    {!isLoandingRecepcion && isFinishRecepcion && (
                        messageErrorSave ? (
                            <Alert key='error' variant='primary' className='mb-8'>
                                <b>Error</b>: {messageErrorSave}
                            </Alert>
                        ) : (
                            <Alert key='info' variant='success' className='mb-8'>
                                {typeCodeGarantia.current === GARANTIA_TIPO.GAR1_CARTA_FIANZA ? (
                                    <>
                                        <b>Recepción Guardada</b>: La Recepción de la Carta Fianza <b>{nroDocumento.current}</b> ha sido guardada exitosamente con el estado de <b>"{recepcionEstadoSelected.label}"</b>.
                                    </>
                                ) : (
                                    <>
                                        <b>Recepción Guardada</b>: La Recepción de la Garantía en Efectivo <b>Nro {nroDocumento.current}</b> ha sido guardada exitosamente con el estado de <b>"{recepcionEstadoSelected.label}"</b>.
                                    </>
                                )}
                            </Alert>
                        )
                    )}

                    <div className='container'>
                        <div className='row'>
                            <div className='col-12 d-flex align-items-center justify-content-end'>
                                {typeCodeGarantia.current === GARANTIA_TIPO.GAR1_CARTA_FIANZA ? (
                                    <label className="fw-bold fs-6 mb-0 me-2">Nro Carta Fianza:</label>
                                ) : (
                                    <label className="fw-bold fs-6 mb-0 me-2">Nro Operación:</label>
                                )}
                                <span>{nroDocumento.current}</span>
                            </div>
                        </div>
                        <div className="row mt-6">
                            <div className="col-12 d-flex align-items-center">
                                <label className="fw-bold fs-6 mb-0 me-4">Estado:</label>
                                <Select
                                    classNamePrefix='filter'
                                    components={makeAnimated()}
                                    value={recepcionEstadoSelected}
                                    options={stateOptionList}
                                    isMulti={false}
                                    closeMenuOnSelect={true}
                                    placeholder="Selecciona"
                                    onChange={(value) => { setRecepcionEstadoSelected(value) }}
                                />
                            </div>
                        </div>
                        {typeCodeGarantia.current === GARANTIA_TIPO.GAR0_EFECTIVO && (
                            <div className="row mt-4">
                                <div className='col-12 d-flex align-items-center'>
                                    <label className="fw-bold fs-6 mb-0 me-6">Fecha:</label>
                                    <DatePicker
                                        className="form-control form-control-solid pe-5"
                                        locale="es"
                                        minDate={new Date()}
                                        value={dateAdmissionRecepcion}
                                        dateFormat="dd/MM/yyyy"
                                        shouldCloseOnSelect={false}
                                        onChange={(date) => {
                                            setDateAdmissionRecepcion(date);
                                        }}
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                </ConfirmWithLoader>
            </PermissionsGate>
        </>
    )
}